import api from "@/assets/js/utils/api"; // 共用 axios 模組（裡面有攔截器和 401 處理）
import {
  showLoading,
  hideLoading,
  showSuccess,
  showError,
} from "@/assets/js/utils/alertService"; // SweetAlert2 提示工具

export default {
  data() {
    return {
      formData: {
        username: "", // 帳號欄位
        password: "", // 密碼欄位
        rememberMe: false, // 記住我
      },
      showPassword: false, // 是否顯示密碼
      isLoading: false, // 登入中狀態
      errorMessage: "", // 顯示錯誤訊息
    };
  },

  created() {
    this.loadRememberInfo(); // 註解: 元件載入時讀取記住的資訊
  },

  methods: {
    // ==========================
    // ✳️ 登入方法
    // ==========================
    async handleLogin() {
      this.isLoading = true;
      this.errorMessage = "";

      try {
        // 🧠 組出後端需要的資料格式
        const payload = {
          account: this.formData.username, // ⚠️ 注意是 accout (後端參數)
          password: this.formData.password,
          ipAddress: await this.getClientIP(), // 取得 IP
        };

        // 🌀 顯示 Loading
        showLoading("登入中，請稍候...");

        // 🚀 呼叫後端登入 API
        const response = await api.post("/employee/login", payload);

        if (response.data.success) {
          // ✅ 登入成功，token 已由 API 攔截器自動保存
          console.log("✅ 登入成功，Token 已保存");

          // 🔍 驗證登入狀態（呼叫 verify API）
          try {
            const verifyRes = await api.get("/back/admin/verify");
            hideLoading();

            if (verifyRes.data.success === true && verifyRes.data.data) {
              // ✅ 驗證成功
              console.log("✅ 登入驗證成功：", verifyRes.data.data);
              showSuccess("登入成功，正在進入系統...");

              // ✅ 清除權限快取，讓路由守卫重新獲取
              window.cachedUserPermissions = null;

              // ✅ 延遲跳轉，讓使用者看到成功訊息
              setTimeout(() => {
                this.$router.push("/admin/dashboard");
              }, 500);
            } else {
              // ❌ 驗證失敗
              this.errorMessage = verifyRes.data.message || "登入驗證失敗";
              showError(this.errorMessage);
            }
          } catch (verifyError) {
            hideLoading();
            console.error("驗證登入狀態失敗:", verifyError);
            this.errorMessage = "無法驗證登入狀態，請稍後再試";
            showError(this.errorMessage);
          }
        } else {
          // ❌ 後端回傳錯誤
          hideLoading();
          this.errorMessage = response.data.message || "登入失敗";
          showError(this.errorMessage);
        }
      } catch (error) {
        hideLoading(); // 關閉 Loading

        console.error("登入發生錯誤:", error);
        this.errorMessage =
          error.response?.data?.message || "無法連線到伺服器，請稍後再試。";

        showError(this.errorMessage);
      } finally {
        this.isLoading = false;
      }
    },

    // ==========================
    // ✳️ 取得使用者 IP
    // ==========================
    async getClientIP() {
      try {
        const res = await fetch("https://api.ipify.org?format=json");
        const data = await res.json();
        return data.ip;
      } catch {
        return "unknown";
      }
    },

    loadRememberInfo() {
      // 註解: 從 localStorage 初始化帳密
      const saved = localStorage.getItem("rememberLogin");

      if (saved) {
        const data = JSON.parse(saved);

        this.formData.username = data.username;
        this.formData.password = atob(data.password); // 註解: base64 解碼
        this.formData.rememberMe = true;
      }
    },
  },
};
